import React, { useMemo } from 'react';

import { isEmpty } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { getTimeOptions } from '@modules/events/utilsTyped';
import { Form, Select } from '@shared/components';
import { timeFormat } from '@shared/constants';
import { intl } from '@shared/localization';

import { getTimePlaceholder } from '../../utils';

const FormItem = Form.Item;
const { Option } = Select;

const ActivityTimeInput = ({
  allDay,
  fieldName,
  fieldTranslationKey,
  initialValue,
  rules,
  disabled,
  form,
}) => {
  const { getFieldDecorator } = form;

  const timeOptions = useMemo(() => getTimeOptions(), []);

  return (
    <React.Fragment>
      <FormItem>
        {getFieldDecorator(fieldName, {
          initialValue: initialValue ? moment(initialValue) : undefined,
          normalize: value =>
            isEmpty(value)
              ? value
              : moment(value, timeFormat).format(timeFormat),
          rules,
        })(
          <Select
            placeholder={getTimePlaceholder({
              allDay,
              type: fieldTranslationKey,
            })}
            size="large"
            rounded
            floatingLabel
            disabled={disabled}
            useCustomMobile={false}
            form={form}
          >
            {timeOptions.map(timeOption => (
              <Option
                key={`${fieldName}${timeOption}`}
                value={timeOption}
                text={timeOption}
              >
                {allDay
                  ? intl.formatMessage({
                      id: 'progress.Form.field.allDayEvent.placeholder',
                    })
                  : timeOption}
              </Option>
            ))}
          </Select>,
        )}
      </FormItem>
    </React.Fragment>
  );
};

ActivityTimeInput.propTypes = {
  allDay: PropTypes.bool,
  fieldTranslationKey: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  initialValue: PropTypes.object,
  rules: PropTypes.array,
  disabled: PropTypes.bool,
  form: PropTypes.object.isRequired,
};

export default ActivityTimeInput;
